module.exports = __webpack_public_path__ + "img/qiyeziping_back.4903506c.jpg";